export const alphabet = "abcdefghijklmnopqrstuvwxyz";

export const isOnlyLettersAndNumbers = (str: string) => {
  return /^[A-Za-z0-9]*$/.test(str);
};

export const isOnlyLetters = (str: string) => {
    return /^[A-Za-z]*$/.test(str);
  };
